module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nif(environment.style == 'mobile'){\nvar title = (model.titleMobile != \"\" ? model.titleMobile : model.title);\nvar text  = (model.textMobile != \"\"  ? model.textMobile  : model.text);\n%>\n<%- include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: model.img, _img: model._img } }); %>\n<%  } else { %>\n<div class=\"texts\">\n<h3><%- model.title %></h3>\n<p><%- model.text %></p>\n<%- include('../../button/button', { model: model }); %>\n</div>\n<div class=\"images<%- (model.isImgAttachedRight ? \" imgAttachedRight\" : \"\") %><%- (model.isImgFullHeight ? \" imgFullHeight\" : \"\") %>\">\n<%          var i1 = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};\nif (!model.isImgFullHeight) {\n%>              <img src=\"<%= i1.url %>\" alt=\"<%= i1.alt %>\" title=\"<%= i1.title %>\">\n<%          } else { %>\n<div style=\"background-image:url(<%= i1.url %>)\"></div>\n<%          } %>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "components/templates/standard/1tbl-1ir/1tbl-1ir.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
if(environment.style == 'mobile'){
var title = (model.titleMobile != "" ? model.titleMobile : model.title);
var text  = (model.textMobile != ""  ? model.textMobile  : model.text);

    ; __line = 6
    ; __append("\n")
    ; __line = 7
    ; __append( include('../../../mobile/1it-1tbb-base/1it-1tbb-base', { model: { title: title, text: text, buttonText: model.buttonText, buttonColor: model.buttonColor, buttonAction: model.buttonAction, img: model.img, _img: model._img } }) )
    ; __append("\n")
    ; __line = 8
    ;   } else { 
    ; __append("\n<div class=\"texts\">\n<h3>")
    ; __line = 10
    ; __append( model.title )
    ; __append("</h3>\n<p>")
    ; __line = 11
    ; __append( model.text )
    ; __append("</p>\n")
    ; __line = 12
    ; __append( include('../../button/button', { model: model }) )
    ; __append("\n</div>\n<div class=\"images")
    ; __line = 14
    ; __append( (model.isImgAttachedRight ? " imgAttachedRight" : "") )
    ; __append( (model.isImgFullHeight ? " imgFullHeight" : "") )
    ; __append("\">\n")
    ; __line = 15
    ;           var i1 = (helpers.detectRenderedImage(model.img, model._img) || {}).rendered || {};
if (!model.isImgFullHeight) {

    ; __line = 17
    ; __append("              <img src=\"")
    ; __append(escapeFn( i1.url ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( i1.alt ))
    ; __append("\" title=\"")
    ; __append(escapeFn( i1.title ))
    ; __append("\">\n")
    ; __line = 18
    ;           } else { 
    ; __append("\n<div style=\"background-image:url(")
    ; __line = 19
    ; __append(escapeFn( i1.url ))
    ; __append(")\"></div>\n")
    ; __line = 20
    ;           } 
    ; __append("\n</div>\n")
    ; __line = 22
    ; 
}

    ; __line = 24
    ; __append("\n</div>")
    ; __line = 25
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/standard/1tbl-1ir/1tbl-1ir.ejs

}